const makeReactiveVarManager = () => {
  const vars = [];
  const reset = () => {
    vars.forEach(v => {
      v.reset();
    });
  };
  const add = v => {
    vars.push(v);
  };
  return {
    reset,
    add
  };
};
export const ReactiveVarManager = makeReactiveVarManager();